import React from 'react';
import { usePremiumAccess } from '../hooks/usePremiumAccess';
import { APP_STORE_URL } from '../utils/subscriptionUtils';

interface PremiumUpgradePromptProps {
  featureName: string;
  description?: string;
  onUpgrade?: () => void;
  compact?: boolean;
}

export function PremiumUpgradePrompt({
  featureName,
  description,
  onUpgrade,
  compact = false,
}: PremiumUpgradePromptProps) {
  return (
    <div className={`rounded-lg border-2 border-[#ffd700]/50 bg-[#ffd700]/10 ${compact ? 'p-4' : 'retro-card p-6'} text-center`}>
      <span className="text-3xl">🌟</span>
      <h3 className="text-lg font-semibold text-[#1f1f1f] mt-2">Premium Feature</h3>
      <p className="text-sm text-[#666] mt-2 max-w-md mx-auto">
        <strong>{featureName}</strong> is included with Early Supporter.
        {description ? ` ${description}` : ' Subscribe on your iPhone to unlock it on web.'}
      </p>
      <div className="mt-4 flex flex-col sm:flex-row gap-3 justify-center">
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="neon-button success text-center"
        >
          Get MacTrack on iPhone
        </a>
        {onUpgrade && (
          <button type="button" onClick={onUpgrade} className="neon-button">
            View subscription
          </button>
        )}
      </div>
    </div>
  );
}

interface PremiumGateProps {
  featureName: string;
  description?: string;
  children: React.ReactNode;
  onUpgrade?: () => void;
}

export default function PremiumGate({
  featureName,
  description,
  children,
  onUpgrade,
}: PremiumGateProps) {
  const { isPremium, loading } = usePremiumAccess();

  if (loading) {
    return (
      <div className="retro-card p-6">
        <div className="text-center py-8 text-[#2d2d2d]">Checking subscription...</div>
      </div>
    );
  }

  if (!isPremium) {
    return (
      <PremiumUpgradePrompt
        featureName={featureName}
        description={description}
        onUpgrade={onUpgrade}
      />
    );
  }

  return <>{children}</>;
}
